import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./ui/Button";
import ToastItem from "./ToastItem";
import { useTicketContext } from "../context/TicketContext";

const ChangeAssignee = () => {
  const navigate = useNavigate();
  const { ticket, showToastMessage, setShowToastMessage, completeWorkFlow } =
    useTicketContext();
  
  // Initializing the state as null or the first option when available
  const [selectedAssignee, setSelectedAssignee] = useState(
    ticket?.assignToOptions?.[0] || ""
  );

  // Effect to update selectedAssignee when ticket.assignToOptions updates
  useEffect(() => {
    if (ticket?.assignToOptions?.length > 0) {
      setSelectedAssignee(ticket.assignToOptions[0]);
    }
  }, [ticket]);

  const handleAssigneeChange = (e) => {
    setSelectedAssignee(e.target.value);
  };

  const completeWorkFlowHandler = async () => {
    try {
      if (!selectedAssignee) {
        console.log("No assignee selected");
        return;
      }
      var resp = await completeWorkFlow(selectedAssignee);
      // Navigate to /abcd after successfully completing the workflow
      //if (resp !== '0')
        navigate("/manage-ticket?page=1");
    } catch (error) {
      console.log("### error while change-assignee #####");
    }
  };

  return (
    <div className="my-10">
      {showToastMessage && (
        <ToastItem
          key={"index"}
          keyPrefix="lineItems"
          item={`Assignee changed to ${selectedAssignee} `}
          index={"index"}
          onRemove={() => setShowToastMessage(false)}
        />
      )}
      <h1 className="font-28-42-400">Change Assignee</h1>

      <p
        className="font-18-400-24 flex items-center gap-2 cursor-pointer"
        onClick={() => navigate(-1)}
      >
        <img className="size-13 rotate--90" src="/Vector.svg" />
        Back
      </p>

      <p className="font-18-400-24">Assign Next to</p>
      <div className="flex space-x-4 items-center">
        <select
          className="sort-selection h-46 font-16-21-400"
          style={{
            backgroundImage: 'url("/arrow-down.svg")',
          }}
          value={selectedAssignee || ""}
          onChange={handleAssigneeChange}
        >
          {ticket?.assignToOptions?.map((option) => (
            <option className="font-16-21-400" key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <Button
          className=" border-none h-42 font-16-700 w-135 capitalize justify-center br-4 create-btn px-8 text-sm font-semibold text-white "
          onClick={completeWorkFlowHandler}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default ChangeAssignee;
